export default "__VITE_ASSET__DWaub8x4__"